import _ from 'lodash';

export function humanTimeDisplay(totalSeconds, options) {
  const { compact, round } = _.defaults(
    options,
    {
      round: true,
      compact: false,
    },
  );
  let minutes;
  let seconds;

  // round to nearest 15 seconds
  if (round) {
    const roundedSeconds = 15 * _.round(totalSeconds / 15);
    minutes = _.floor(roundedSeconds / 60);
    const rawSeconds = roundedSeconds % 60;
    if (minutes) {
      seconds = 15 * _.round(rawSeconds / 15);
    } else {
      seconds = 5 * _.round(rawSeconds / 5);
    }
  } else {
    seconds = totalSeconds % 60;
    minutes = _.floor(totalSeconds / 60);
  }

  let out = '';

  if (compact) {
    out = `${minutes}:${_.padStart(seconds, 2, '0')}`;
  } else {
    if (minutes === 0 && seconds === 0) {
      return 'No wait';
    }
    if (minutes) {
      out += `${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }
    if (minutes && seconds) {
      out += ', ';
    }
    if (seconds) {
      out += `${seconds} seconds`;
    }
  }
  return out;
}
